import React, { useRef, useState } from 'react';
import ImageLoader from '../../images/ImageLoader';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { Button } from 'react-bootstrap';
import { Field, Form, Formik } from 'formik';
import OrderNumberField from './OrderNumberField';

var OnlineReceipt = function OnlineReceipt(props) {
  var _model$MobileCopy;

  var model = props.model;
  var formikRef = useRef();
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-online-miss-credit"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-online-miss-credit__header"
  }, (model === null || model === void 0 ? void 0 : (_model$MobileCopy = model.MobileCopy) === null || _model$MobileCopy === void 0 ? void 0 : _model$MobileCopy.value) || ''), /*#__PURE__*/React.createElement("div", {
    className: "cb-online-miss-credit__container"
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-online-miss-credit__logo-image-container'
  }, /*#__PURE__*/React.createElement(ImageLoader, {
    media: model === null || model === void 0 ? void 0 : model.Image,
    type: 'product',
    className: "cb-online-miss-credit__logo-image"
  })), /*#__PURE__*/React.createElement(RichText, {
    className: 'cb-online-miss-credit__order-number-copy',
    field: model.Copy
  }), /*#__PURE__*/React.createElement(Formik, {
    innerRef: formikRef,
    initialValues: {
      orderNumber: ''
    },
    validateOnMount: true,
    validate: function validate(values) {
      var errors = {};

      if (!values.orderNumber || !/^\d{7}(?:\d{10})?$/i.test(values.orderNumber)) {
        var _model$ErrorMessage;

        errors.orderNumber = ((_model$ErrorMessage = model.ErrorMessage) === null || _model$ErrorMessage === void 0 ? void 0 : _model$ErrorMessage.value) || '';
      }

      return errors;
    },
    onSubmit: function onSubmit(values, _ref) {
      var setSubmitting = _ref.setSubmitting;
      props.handleSubmitOrderNumber(values.orderNumber, 'online', formikRef).then(function () {
        setSubmitting(false);
      });
    }
  }, function (_ref2) {
    var _model$HintText, _model$SubmitCTA;

    var isSubmitting = _ref2.isSubmitting,
        isValid = _ref2.isValid,
        values = _ref2.values;
    return /*#__PURE__*/React.createElement(Form, {
      className: "cb-online-miss-credit__order-number-form"
    }, /*#__PURE__*/React.createElement(Field, {
      type: "digits",
      maxLength: 17,
      name: "orderNumber",
      className: "cb-form__input--full cb-online-miss-credit__order-number",
      label: ((_model$HintText = model.HintText) === null || _model$HintText === void 0 ? void 0 : _model$HintText.value) || '',
      component: OrderNumberField,
      changeHandler: function changeHandler() {},
      value: values.orderNumber
    }), /*#__PURE__*/React.createElement(Button, {
      type: "submit",
      disabled: isSubmitting || !isValid,
      className: "cb-button-primary loyalty--sign-in-form__submit"
    }, ((_model$SubmitCTA = model.SubmitCTA) === null || _model$SubmitCTA === void 0 ? void 0 : _model$SubmitCTA.value) || ''));
  })), /*#__PURE__*/React.createElement(RichText, {
    className: "cb-online-miss-credit__disclaimer",
    field: model === null || model === void 0 ? void 0 : model.Disclaimer
  }));
};

export default OnlineReceipt;